<div class="main-container-admin">
  <!--&================= TITLE =================&-->
  <div class="title-components">
    <h1>Cabeceras Librerías</h1>
  </div>

  <!--&================= CONTAINER OPTION CARD =================&-->
  <div class="Options-Menu">
    <!---================= CONTAINER CARD  =================--->
    <ng-container *ngFor="let Header of HeadersCDMS">
      <div *ngIf="UserService.UserRoleGeneralIn(Header.Roles)" class="Card-Option container-global-components">
        <div class="Icon-Left">
          <div class="Local-Icon-Card button-square">
            <i class="fa-solid {{ Header.Icon }}"></i>
          </div>
        </div>

        <div class="Container-Card">
          <div class="Option-Title">
            <h2>Modificar cabeceras {{ Header.Title }}</h2>
          </div>

          <div class="Input-Option DisplayInputs">
            <div class="Container-Buttons">
              <div
                routerLink="{{ Header.RouterLink }}"
                class="Btn-Option button-square"
              >
                <span class="Tool-Tip">{{ Header.Tooltip }}</span>
                <i class="fa-regular {{ Header.IconButton }}"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!--&================= CONTAINER ROUTE HEADERS =================&-->
  <div class="Container-Router-Header">
    <router-outlet></router-outlet>
  </div>
</div>
